import React, { useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadSummaryDataInsufficientComponent from './LeadSummaryDataInsufficientComponent';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import LeadRecommendationPopupContent from './LeadRecommendationPopupContent';

interface LeadSummaryResponseTimeCardComponentProps {
    data: any,
}

const LeadSummaryResponseTimeCardComponent: React.FC<LeadSummaryResponseTimeCardComponentProps> = ({ data }) => {
    const [openReadMore, setOpenReadMore] = useState<boolean>(false);
    const readMoreHandler  = () => {
        document.body.classList.add("no-overflow");
        setOpenReadMore(true)
    }
    let leadCallingScoreType = data?.leadCallingScoreType ? data.leadCallingScoreType.toLowerCase() : "";
    return (
        <div className={styles.LqscsCard}>
            <div className={styles.LqscsCardHeader}>
                <div className={styles.LqscsCardTitle}>{data.cardTitle}</div>
                <div className={styles.LqscsCardSubTitle}>{data.cardSubtitle}</div>
            </div>
            {
                (data.report_display === "N") ?
                    <LeadSummaryDataInsufficientComponent
                        leadHighlightText={data.thresholdDesc}
                        infoBannerText="Your need to make calls quicker for better conversion"
                        data={data}
                    />
                    :
                    <div className={styles.LqscsCardBody}>
                        <div className={styles.LqscsCardBodyLeft}>
                            <div className={styles.LqscsCardrstListWrap}>
                                <div className={styles.LqscsCardrstTitle}>Leads called</div>
                                <div className={styles.LqscsCardrstList}>
                                    <div className={styles.LqscsCardrstRow}>
                                        <span className={styles.LqscsCardrstLebel}>Within 1 hour</span>
                                        <span className={`${styles.LqscsCardrstValue} ${styles.textgreen}`}>{data.widthInHour}</span>
                                    </div>
                                    <div className={styles.LqscsCardrstRow}>
                                        <span className={styles.LqscsCardrstLebel}>1-6 hours</span>
                                        <span className={`${styles.LqscsCardrstValue} ${styles.textgreen}`}>{data.onetosixHours}</span>
                                    </div>
                                    <div className={styles.LqscsCardrstRow}>
                                        <span className={styles.LqscsCardrstLebel}>6-24 hours</span>
                                        <span className={`${styles.LqscsCardrstValue} ${styles.textyellow}`}>{data.sixto24Hours}</span>
                                    </div>
                                    <div className={styles.LqscsCardrstRow}>
                                        <span className={styles.LqscsCardrstLebel}>After 24 hours</span>
                                        <span className={`${styles.LqscsCardrstValue} ${styles.textred}`}>{data.aftertwfourHours}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={styles.LqscsPercentageInfo}>
                                <div className={styles.LqscsPercentageData}>
                                    <div className={styles.LqscsPercentageDataVal}>{data.leadCalledPercent}<span className={styles.LqscsPercentageDataLabel}>Leads Called</span></div>
                                    <div className={styles.LqscsPercentageDataLabel}>within 1 hour</div>
                                </div>
                                <div className={styles.LqscsScroreType}>
                                    <div className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType}</div>
                                    {(leadCallingScoreType !== "moderate") && <div className={`${styles.LqscsScroreTypeTxt} ${styles[leadCallingScoreType]}`}>Among {(leadCallingScoreType == "good") && "Top"} {(leadCallingScoreType == "poor") && "Bottom"} 20%</div>}
                                </div>
                            </div>
                            <div className={styles.LqscsHighlight}>Top agents in your city respond to leads in {data.topBenchmark}.</div>
                            <div className={`${styles.LqscsBanner} ${styles[leadCallingScoreType]}`}>
                                <span className={`${styles.LqscsBannerIcon} ${styles[leadCallingScoreType]}`}>
                                    {(leadCallingScoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                                    {(leadCallingScoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                    {(leadCallingScoreType == "poor") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                </span>
                                {
                                    data.leadCallingScoreMessage
                                    // (leadCallingScoreType == "good") ? "Awesome! Keep responding to leads on time."
                                    //     :
                                    //     (leadCallingScoreType == "moderate") ? "Your need to make calls quicker for better conversion"
                                    //         :
                                    //         (leadCallingScoreType == "poor") ? "Your need to make calls quicker for better conversion"
                                    //             :
                                    //             ""
                                }
                                <span className={styles.ReadMoreCta} onClick={readMoreHandler}>Read More</span>
                            </div>
                        </div>
                    </div>
            }
            {
                openReadMore && <CenteredPopUp
                    setModal={setOpenReadMore}
                    children={
                        <LeadRecommendationPopupContent 
                        title={"Response Time"}
                        subtext={"This metric shows the percentage of leads called within an hour of receiving them."}
                        recommendation={"Since the report is based on your calls through ReadPro CRM, making calls here helps track key metrics like response time and follow-ups. This allows you to improve efficiency and increase lead conversions."}
                        scoreType={leadCallingScoreType}
                        />
                    }
                    modiferClass={styles.LcqModal}
                    closeIcon={true}
                    closeClassMofifier={styles.LcqModalClose}
                />
            }
        </div>
    )
}

export default LeadSummaryResponseTimeCardComponent